// Shared mapping from a `report/team_management_sums/get` response (campaign-wide
// or scoped via `parent_team_id`) to the `statistics` object teamsOverview.vue renders.
// Used by teamManagement.vue (campaign-wide panel) and childrenTeams.vue (panel scoped
// to a parent team's direct children), so both stay in sync with the same formulas.

export function emptyTeamStatistics() {
  return {
    totalDonors: 0,
    totalGoals: 0,
    totalDirectRaised: 0,
    totalIndirectRaised: 0,
    diff: 0,
    averageDonation: 0,
    progress: 0,
    teamsCount: 0,
  };
}

export function mapTeamStatistics(attrs) {
  const teamsCount = Number(attrs.teams_count) || 0;

  if (teamsCount === 0) {
    return emptyTeamStatistics();
  }

  const totalDonors = Number(attrs.total_direct_donors) || 0;
  const totalGoals = Number(attrs.total_display_goal) || 0;
  const totalDirectRaised = Number(attrs.total_direct_raised) || 0;
  const totalIndirectRaised = Number(attrs.total_indirect_raised) || 0;
  const diff = totalDirectRaised - totalGoals;
  let averageDonation = Math.floor((totalDirectRaised / totalDonors).toFixed(2));
  averageDonation = averageDonation > 0 ? averageDonation : 0;
  const progress = Math.floor((totalDirectRaised / totalGoals) * 100);

  return {
    totalDonors,
    totalGoals,
    totalDirectRaised,
    totalIndirectRaised,
    diff,
    averageDonation,
    progress,
    teamsCount,
  };
}
